module.exports = __webpack_public_path__ + "img/client_logo_5.a2d078f6.svg";